import "../privacyCentre.css";

export default function PrivacyPolicy() {
	return (
		<>
			<h2 className="pc-page-title">Privacy Policy</h2>
			<h3 className="pc-section-title">
				<strong>General Information</strong>
			</h3>
			<p className="pc-detail-text">
				This privacy policy covers all web operations for <em>SpotLite</em>. All information stored on this site
				is for use only within the operations of <em>SpotLite</em>. If you require any more information or have
				any questions about our privacy policy, please feel free to contact us by email at{" "}
				<a href="mailto:privacy@spotlite.co.uk">privacy@spotlite.co.uk</a>. At spotlite.co.uk we consider the
				privacy of our visitors to be extremely important. This privacy policy document describes in detail the
				types of personal information is collected and recorded by spotlite.co.uk and how we use it.
			</p>
			<h3 className="pc-section-title">
				<strong>Log Files</strong>
			</h3>
			<p className="pc-detail-text">
				Like many other Web sites, spotlite.co.uk makes use of log files. These files merely logs visitors to
				the site - usually a standard procedure for hosting companies and a part of hosting services's
				analytics. The information inside the log files includes internet protocol (IP) addresses, browser type,
				Internet Service Provider (ISP), date/time stamp, referring/exit pages, and possibly the number of
				clicks. This information is used to analyse trends, administer the site, track user's movement around
				the site, and gather demographic information. IP addresses, and other such information are not linked to
				any information that is personally identifiable. The majority of this information is saved, tracked, and
				logged automatically by our hosting company, Netlify.
			</p>
			<h3 className="pc-section-title">
				<strong>Spotify Itegration</strong>
			</h3>
			<p className="pc-detail-text">
				By continuing to use the services of this site, you also agree to the privacy policy set out by Spotify,
				with regards to using their services through a third party. As a third party, we also agree to the terms
				of Spotify's privacy policy, with regards to the data held about our users, and their engagement with
				Spotify. We do not hold any more information than is necessary for our users to make use of our
				facilities. Such information includes authorisation details, such as expiry markers, refresh tokens,
				access tokens, and authorisation codes required to connect our users to Spotify. We also save
				information about previously played tracks, and previous search results.
			</p>
			<p className="pc-detail-text">
				In order to enable you to use this website with Spotify services, we save certain functionally important
				Spotify information about you in this website if you log in with Spotify. If you request that your data
				be deleted from this website, this data will also be deleted and Spotify functionality will not work.
				You would need to register on this website and log in to this website with Spotify again in order to
				re-populate this data and have Spotify functionality working again.
			</p>
			<h3 className="pc-section-title">
				<strong>User Uploaded Media</strong>
			</h3>
			<p className="pc-detail-text">
				If you upload images to the website, you should avoid uploading images with embedded location data
				(EXIF, GPS) included. Visitors to the website can download and extract any location data from images on
				the website. Similarly, music with ID3 tags can also have information extracted from them.
			</p>
			<h3 className="pc-section-title">
				<strong>Embedded content from other websites</strong>
			</h3>
			<p className="pc-detail-text">
				Elements on this site may include embedded content (e.g. videos, images, articles, etc.). Embedded
				content from other websites behaves in the exact same way as if the visitor has visited the other
				website. These websites may collect data about you, use cookies, embed additional third-party tracking,
				and monitor your interaction with that embedded content, including tracing your interaction with the
				embedded content if you have an account and are logged in to that website.
			</p>
			<h3 className="pc-section-title">
				<strong>How long we retain your data</strong>
			</h3>
			<p className="pc-detail-text">
				For users that register on our website, we store the personal information they provide in their user
				profile indefinitely. All users can see, edit, or delete their personal information at any time. Website
				administrators can also see and edit that information; even when the website is offline.
			</p>
			<h3 className="pc-section-title">
				<strong>What rights you have over your data</strong>
			</h3>
			<p className="pc-detail-text">
				If you have an account on this site, you can request to receive an exported file of the personal data we
				hold about you, including any data you have provided to us. You can also request that we erase any
				personal data we hold about you. This does not include any data we are obliged to keep for
				administrative, legal, or security purposes.
			</p>
			<h3 className="pc-section-title">
				<strong>Cookies and Web Beacons</strong>
			</h3>
			<p className="pc-detail-text">
				spotlite.co.uk uses cookies to store information about visitors' preferences, to record user-specific
				information on which pages the site visitor accesses or visits, and to personalise or customise our web
				page content based upon visitors' browser type or other information that the visitor sends via their
				browser.
			</p>
			<h3 className="pc-section-title">
				<strong>Third Party Privacy Policies</strong>
			</h3>
			<p className="pc-detail-text">
				You should consult the respective privacy policies of these third-party ad servers for more detailed
				information on their practices as well as for instructions about how to opt-out of certain practices.
				spotlite.co.uk's privacy policy does not apply to, and we cannot control the activities of, such other
				advertisers or web sites. You may find a comprehensive listing of these privacy policies and their links
				here:{" "}
				<a title="Privacy Policy Links" href="http://www.privacypolicyonline.com/privacy-policy-links">
					Privacy Policy Links.
				</a>
			</p>
			<p className="pc-detail-text">
				If you wish to disable cookies, you may do so through your individual browser options. More detailed
				information about cookie management with specific web browsers can be found at the browsers' respective
				websites. <a href="http://www.privacypolicyonline.com/what-are-cookies">What Are Cookies?</a>
			</p>
			<h3 className="pc-section-title">
				<strong>Children's Information</strong>
			</h3>
			<p className="pc-detail-text">
				We believe it is important to provide added protection for children online. We encourage parents and
				guardians to spend time online with their children to observe, participate in and/or monitor and guide
				their online activity. spotlite.co.uk does not knowingly collect any personally identifiable information
				from children under the age of 13. If a parent or guardian believes that spotlite.co.uk has in its
				database the personally-identifiable information of a child under the age of 13, please contact us
				immediately (using the contact in the first paragraph) and we will use our best efforts to promptly
				remove such information from our records.
			</p>
			<h3 className="pc-section-title">
				<strong>Online Privacy Policy Only</strong>
			</h3>
			<p className="pc-detail-text">
				This privacy policy applies only to our online activities and is valid for visitors to our website and
				regarding information shared and/or collected there. This policy does not apply to any information
				collected offline or via channels other than this website.
			</p>
			<h3 className="pc-section-title">
				<strong>Consent</strong>
			</h3>
			<p className="pc-detail-text">
				By using our website, you hereby consent to our privacy policy and agree to its terms.
			</p>
			<h3 className="pc-section-title">
				<strong>Update</strong>
			</h3>
			<p className="pc-detail-text">This Privacy Policy was last updated on: Monday 15th May, 2023. </p>
			<p className="pc-detail-text">
				<em>
					Should we update, amend or make any changes to our privacy policy, those changes will be posted
					here.
				</em>
			</p>
		</>
	);
}
